import { useMemo } from "react";

import { queryGetEmployeeAccess } from "@type/api/businessUnit";
import { useBusinessUnitStore } from "@type/store";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import { TGetEmployeeAccessReq } from "@type/api/businessUnit/types";
import { TBooleanRecord } from "types/index";

interface UseGetEmployeeAccessProps {
  params?: TGetEmployeeAccessReq;
}

export const useGetEmployeeAccess = ({ params }: UseGetEmployeeAccessProps) => {
  const queryGetEmployeeAccessKey = useMemo(() => {
    return queryGetEmployeeAccess._key(params);
  }, [params]);

  const onSetBUAccessRight = useBusinessUnitStore(
    (state) => state.onSetBUAccessRight
  );

  const { isLoading: isLoadingGetEmployeeAccess } = useQueryWithCallbacks({
    queryKey: queryGetEmployeeAccessKey,
    enabled: !!params?.userId && !!params.buId,
    queryFn: () => queryGetEmployeeAccess(params),
    onSuccess: (res) => {
      const objAccess: TBooleanRecord = {};
      for (const access of res.access) {
        objAccess[access.id] = access.status;
        for (const subAccess of access.sub) {
          objAccess[subAccess.id] = subAccess.status;
        }
      }
      onSetBUAccessRight(objAccess);
    },
  });

  return {
    isLoadingGetEmployeeAccess,
  };
};
